"use client";

import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/redux/store";
import { setCartCount } from "@/redux/features/AddToCart/cartSlice";
import Icon from "../icons/Icons";
import { useLoginModal } from "@/utils/useLoginModal";
import { apiGet } from "@/utils/apiClient";
import { useRouter } from "next/navigation";

type CartData = {
  status: number;
  total: number;
};

export default function CartCountButton() {
  const [mounted, setMounted] = useState(false);
  const cartCount = useSelector((state: RootState) => state.cart.count);
  const dispatch = useDispatch();
  const { isLoggedIn, open, setModalKey } = useLoginModal();
  const router = useRouter();

  const fetchCartList = useCallback(async () => {
    try {
      const response = await apiGet<CartData>("cartCount");

      if (response.status) {
        dispatch(setCartCount(response.total));
      }
    } catch (error) {
      console.error("Error fetching cart list:", error);
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    if (!isLoggedIn) return;
    fetchCartList();
  }, [fetchCartList, isLoggedIn]);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleLogin = () => {
    if (!isLoggedIn) {
      open();
      setModalKey("header-cart-button");
    } else {
      router.push("https://dashboard.mysiponline.com/cart");
    }
  };

  if (!mounted) return <CartCount />;

  return (
    <>
      {isLoggedIn ? (
        <a href="https://dashboard.mysiponline.com/cart" aria-label="Funds Cart Button">
          <CartCount cartCount={cartCount} />
        </a>
      ) : (
        <button onClick={handleLogin} aria-label="Funds Cart Button">
          <CartCount cartCount={cartCount} />
        </button>
      )}
    </>
  );
}

const CartCount = ({ cartCount }: { cartCount?: number }) => {
  return (
    <div className="group py-3 m-0 cursor-pointer relative">
      <Icon.headerCartIcon
        className={`transition w-9 h-9 sm:w-10 sm:h-10 duration-300 rounded-full text-white border border-transparent group-hover:border-white`}
      />
      <span className="rounded-full bg-[#EC4D4D] w-3.5 h-3.5 text-center text-[10px] leading-3 absolute right-1.5 top-4 text-white">
        {cartCount ?? 0}
      </span>
    </div>
  );
};
